import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projectmaster-grid',
  templateUrl: './projectmaster-grid.component.html',
  styleUrls: ['./projectmaster-grid.component.css']
})
export class ProjectmasterGridComponent implements OnInit {

  constructor() { }

  title="Project Master";
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/project-master/projectmaster-grid/projectmaster-grid.component.ts